export default __webpack_public_path__ + "static/media/twenty-eight-days-poster.f26423a4.jpeg";